import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CalendarView } from 'angular-calendar';

@Component({
  selector: 'app-calendar-week-header',
  templateUrl: './calendar-week-header.component.html',
  styleUrls: ['./calendar-week-header.component.scss']
})
export class CalendarWeekHeaderComponent implements OnInit {

  @Input() view: CalendarView;

  @Input() viewDate: Date;

  @Input() locale: string = 'en';

  @Output() viewChange = new EventEmitter<CalendarView>();

  @Output() viewDateChange = new EventEmitter<Date>();

  CalendarView = CalendarView;
  
  constructor() { }

  ngOnInit(): void {
  }

  
}
